import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Sidebar } from '../../shared/components/sidebar/sidebar';
import { Navbar } from '../../shared/components/navbar/navbar';
import {
  BrainActivity as BrainActivityService,
  BrainActivitySummary,
  ConnectedTools,
  FrequentQuery
} from '../../core/services/brain-activity';

@Component({
  selector: 'app-brain-activity',
  standalone: true,
  imports: [CommonModule, Sidebar, Navbar],
  templateUrl: './brain-activity.html',
  styleUrl: './brain-activity.css'
})
export class BrainActivityPage implements OnInit {
  private brainActivityService = inject(BrainActivityService);
  private router = inject(Router);

  summary = signal<BrainActivitySummary | null>(null);
  connectedTools = signal<ConnectedTools | null>(null);
  frequentQueries = signal<FrequentQuery[]>([]);

  kgExpanded = signal(true);
  sqlExpanded = signal(false);
  vectorExpanded = signal(false);

  ngOnInit(): void {
    this.brainActivityService.getSummary().subscribe({
      next: res => this.summary.set(res.data),
      error: () => this.summary.set(null)
    });

    this.brainActivityService.getConnectedTools().subscribe({
      next: res => this.connectedTools.set(res.data),
      error: () => this.connectedTools.set(null)
    });

    this.brainActivityService.getFrequentQueries().subscribe({
      next: res => this.frequentQueries.set(res.data ?? []),
      error: () => this.frequentQueries.set([])
    });
  }

  toggleKg(): void { this.kgExpanded.update(v => !v); }
  toggleSql(): void { this.sqlExpanded.update(v => !v); }
  toggleVector(): void { this.vectorExpanded.update(v => !v); }

  openDetail(): void {
    this.router.navigate(['/brain-activity/detail']);
  }

  sqlTotalRows(t: ConnectedTools): number {
    return t.sqlDatabase.reduce((sum, table) => sum + table.count, 0);
  }

  connectorSegmentWidth(part: number, q: FrequentQuery): number {
    const total = q.connectorBreakdown.chatbot + q.connectorBreakdown.inference + q.connectorBreakdown.api;
    return total > 0 ? Math.round((part / total) * 100) : 0;
  }
}
